<!-- Loading Screen -->

@if (isReportSending) {
  <div class="wrapper center"
    >
    <div class="inner">
      <mat-spinner> </mat-spinner>
    </div>
  </div>
}

<!-- Offload Catch Report-->

@if (!isReportSending) {
  <div class="container catch-container">
    <h2 i18n="@@testTitle" #test [hidden]="true">No catch entered</h2>
    <!-- Spinner & Page Count -->
    <div class="container"
      style="padding-top: 20px;">
      <div class="row"
        align="center">
        @if (currPage <= numPages) {
          <h6 i18n>
        <small class="text-muted">
          Page {{currPage}} of {{numPages}}
        </small>
      </h6>
        }
        @if (currPage > numPages) {
          <h6 i18n>
        <small class="text-muted">
          Offload Catch Report
        </small>
      </h6>
        }
      </div>
      <div class="row" align="center">
        <div class="col" style="display: flex; justify-content: space-between;">
          <mat-icon></mat-icon>
          @if (currPage <= numPages) {
            <mat-spinner
              mode="determinate"
              [diameter]="50"
              [strokeWidth]="6"
            [value]="spinnerProgress"></mat-spinner>
          }
          @if (currPage > numPages && !isComplete) {
            <mat-icon
              style="color:#3ebfb9">
              check_circle_outline
            </mat-icon>
          }
          @if (!isComplete) {
            <button mat-mini-fab matTooltip="Delete Report" [disabled]="isEditing" style="background-color: #005d87;" (click)="deleteReport()">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
    <form [formGroup]="offloadForm">
      <!-- Offload Date & Time -->
      @if (currPage === 1) {
        <div
          class="container details">
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          When did you offload?
        </h5>
          </div>
          <div class="row"
            align="center">
            <div class="col-2"></div>
            <div class="col-8">
              <mat-card class="demo-inline-calendar-card calendar-width" style="margin-top: 5%">
                <mat-calendar [(selected)]="offloadDate" (selectedChange)="dateTimeChange()"
                [minDate]="sharedMethodsService.getMinDate(currTrip)" [maxDate]="currDate"></mat-calendar>
              </mat-card>
              <div class="outer">
                <div class="inner-2">
                  <h6 i18n class="blue-label">
                Time (24hr): &nbsp;
              </h6>
                </div>
                <div class="inner-2">
                  <ngb-timepicker class="time-picker"
                    [spinners]="false"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="offloadTime"
                  (ngModelChange)="dateTimeChange()"></ngb-timepicker>
                </div>
              </div>
              @if (futureDateTimeError) {
                <div class="row" align="center">
                  <span i18n class="invalid-field">
                    The date and time cannot be in the future
                  </span>
                </div>
              }
            </div>
          </div>
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          Where did you offload?
        </h5>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
          Landing Site
        </h6>
          </div>
          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label i18n>
            Site Name
          </mat-label>
              <mat-select formControlName="landingSite" [compareWith]="compareWith">
                @for (site of relevantLandingSites; track site) {
                  <mat-option i18n
                    [value]="site">
              @if (site.name == 'Not Listed' || site.name == 'Not Offloading / No Catch') {
<div>
                {site, select, Not Listed {Not Listed} Not Offloading / No Catch {Not Offloading / No Catch}}
              </div>
}
              @if (site.name != 'Not Listed' && site.name != 'Not Offloading / No Catch') {
<div>
                {{site}}
              </div>
}
            </mat-option>
                }
              </mat-select>
              @if (offloadForm.invalid) {
                <mat-error i18n>
            Required
          </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      }
      <!-- Fishing Dates, Management & Subarea -->
      @if (currPage === 2) {
        <div>
          <h5 i18n class="blue-heading-title"
            align="center">
        Where Did You Last Fish?
      </h5>
          <h6 i18n class="blue-heading">
        Last Management Area Fished
      </h6>
          <div class="row"
            align="center">
            <mat-form-field appearance="outline">
              <mat-label i18n>
            Management Area
          </mat-label>
              <mat-select formControlName="mgmtArea" [compareWith]="compareArea">
                @for (area of managementAreas; track area) {
                  <mat-option [value]="area">{{area}}</mat-option>
                }
              </mat-select>
              @if (offloadForm.invalid) {
                <mat-error i18n>
            Required
          </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="row">
            <h6 i18n class="blue-heading"
              style="margin-top: 5px;">
          Last Subarea Fished
        </h6>
            <mat-form-field appearance="outline">
              <mat-label i18n>
            Subarea
          </mat-label>
              <mat-select formControlName="subarea" [compareWith]="compareArea">
                @for (subArea of subAreas; track subArea) {
                  <mat-option
                    [value]="subArea">
                    {{subArea}}
                  </mat-option>
                }
              </mat-select>
              @if (offloadForm.invalid) {
                <mat-error i18n>
            Required
          </mat-error>
              }
            </mat-form-field>
          </div>
          <h5 i18n class="blue-heading-title"
            align="center">
        How Many Days Did You Fish?
      </h5>
          <div class="row">
            <h6 i18n class="blue-heading">
          First and Last Date Fished
        </h6>
            <mat-form-field appearance="outline">
              <mat-label i18n>
            MM/DD/YYYY – MM/DD/YYYY
          </mat-label>
              <mat-date-range-input [rangePicker]="picker"
                [min]="sharedMethodsService.getMinDate(currTrip)"
                [max]="currTrip.endFishingReport.endDate">
                <input matStartDate
                  formControlName="startDate"
                  placeholder="Start date"
                  i18n-placeholder="Start date placeholder" />
                  <input matEndDate
                    formControlName="endDate"
                    placeholder="End date"
                    i18n-placeholder="End date placeholder" />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matIconSuffix
                  [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker touchUi
                  #picker></mat-date-range-picker>
                  @if (offloadForm.invalid) {
                    <mat-error i18n>
            {dateError, select, Invalid Date Range {Invalid Date Range} Required {Required}}
          </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="row">
                <h6 i18n class="blue-heading"
                  style="margin-top: 5px;">
          Number of Days Fished
        </h6>
                <mat-form-field appearance="outline">
                  <mat-label i18n>
            Days
          </mat-label>
                  <input matInput
                    maxlength="3"
                    inputmode="numeric"
                    formControlName="numDaysFished"
                    (input)="sharedMethodsService.forbidNonNumeric('numDaysFished', offloadForm)">
                    @if (offloadForm.invalid) {
                      <mat-error i18n>
            Required
          </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            }
            <!-- Fish Slip, Product Type, and Units Information -->
            @if (currPage === 3) {
              <div>
                <div>
                  <div class="row"
                    align="center">
                    <h6 i18n class="blue-label"
                      align="left">
            Fish Slip Number (leave blank if none issued)
          </h6>
                    <mat-form-field appearance="outline"
                      class="form-field">
                      <mat-label i18n>
              Fish Slip Number
            </mat-label>
                      <input matInput
                        maxlength="20"
                        formControlName="fishSlipNumber" />
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Product Type (consider moving to own page) -->
                  <div class="row"
                    align="center">
                    <h5 i18n class="blue-heading-title">
          How was the catch processed? <!-- how should we phrase this? -->
        </h5>
                  </div>
                  <h6 i18n class="blue-label">
        Product Type
      </h6>
                  <div class="row"
                    align="center">
                    <mat-form-field appearance="outline"
                      class="form-field">
                      <mat-label i18n>
            Product Type
          </mat-label>
                      <mat-select formControlName="productType" [compareWith]="compareWith">
                        @for (productType of productTypes; track productType) {
                          <mat-option i18n
                            [value]="productType">
              {productType, select, Unknown {Unknown} Round, Fresh {Round, Fresh} Dressed, Head On, Fresh {Dressed, Head On, Fresh} Dressed, Head Off, Fresh {Dressed, Head Off, Fresh} Round, Frozen {Round, Frozen} Dressed, Head On, Frozen {Dressed, Head On, Frozen} Dressed, Head Off, Frozen {Dressed, Head Off, Frozen} Roe, Fresh {Roe, Fresh} Round, Unknown Preservation {Round, Unknown Preservation}}
            </mat-option>
                        }
                      </mat-select>
                      @if (offloadForm.invalid) {
                        <mat-error i18n>
            Required
          </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <!-- Weight Units -->
                  @if (getCurrentGearType() === 'Seine') {
                    <div class="row"
                      align="center">
                      <h5 i18n class="blue-heading-title">
          How would you like to record catch weight?
        </h5>
                      <h6 i18n class="blue-label"
                        align="left">
          Units
        </h6>
                      <mat-form-field appearance="outline"
                        class="form-field">
                        <mat-label i18n>
            Units
          </mat-label>
                        <mat-select formControlName="weightUnits">
                          @for (weightUnit of weightUnitOptions; track weightUnit) {
                            <mat-option
                              [value]="weightUnit">
                              {{weightUnit}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (offloadForm.invalid) {
                          <mat-error i18n>
            Required
          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  }
                </div>
              }
              <!-- Catch Table Page -->
              @if (currPage === 4) {
                <div>
                  <!-- Table -->
                  <div class="row"
                    align="center">
                    <h5 i18n class="blue-heading-title">
          Offload Catch Table
        </h5>
                  </div>
                  @if (getCurrentGearType() === 'Seine') {
                    <h6 i18n class="blue-label"
                      >
        Please record total catch for each species in
        <b>either </b> <i>weight </i> <b>or </b> <i>pieces</i>.
      </h6>
                  }
                  @if (getCurrentGearType() === 'Gill Net') {
                    <h6 i18n class="blue-label"
                      >
        Please record total catch for each species in <i>pieces</i>.
      </h6>
                  }
                  @if (currTrip.dailyCatchReports.length) {
                    <button
                      mat-raised-button
                      class="fishing-button-light-blue"
                      type="button"
                      (click)="offloadTableDialog()">
                      <span i18n>
          Populate Table
        </span>
                    </button>
                  }
                  <table mat-table
                    [dataSource]="tableDataSource"
                    class="mat-elevation-z8 margin-table">
                    <!-- Name Column -->
                    <ng-container matColumnDef="speciesName">
                      <tr>
                        <th i18n mat-header-cell
                          *matHeaderCellDef
                          class="heading-cell">
              Species
            </th>
                        <td mat-cell
                          *matCellDef="let element">
                          {{element.speciesName}}
                        </td>
                      </tr>
                    </ng-container>
                    <!-- Weight Column (Seine only) -->
                    @if (getCurrentGearType() === 'Seine') {
                      <ng-container
                        matColumnDef="weight">
                        <tr>
                          <th i18n mat-header-cell
                            *matHeaderCellDef
                            class="heading-cell">
              Weight <small>({{getWeightUnits()}})</small>
            </th>
                          <td mat-cell [ngClass]="catchService.determineCellStyling(element.offloadWeight)"
                            *matCellDef="let element">
                            {{element.offloadWeight}}
                          </td>
                        </tr>
                      </ng-container>
                    }
                    <!-- Pieces Column -->
                    <ng-container matColumnDef="pieces">
                      <tr>
                        <th i18n mat-header-cell
                          *matHeaderCellDef
                          class="heading-cell">
              Pieces
            </th>
                        <td mat-cell [ngClass]="catchService.determineCellStyling(element.offloadPieces)"
                          *matCellDef="let element">
                          {{element.offloadPieces}}
                        </td>
                      </tr>
                    </ng-container>
                    <!-- Rows -->
                    <tr mat-header-row
                    *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row
                      *matRowDef="let row; columns: displayedColumns; let index=index;"
                    (click)="updateSpeciesTable(index)"></tr>
                  </table>
                  <!-- Fish Totals -->
                  <div class="row" style="padding-top: 10px;">
                    @if (getCurrentGearType() === 'Seine') {
                      <h6 i18n
                        style="color: #003F61">
          <b>
            Total Weight:
          </b>
          {{catchService.calculateTotalFish('weight', tableDataSource)}}
        </h6>
                    }
                    <h6 i18n style="color: #003F61">
          <b>
            Total Pieces:
          </b>
          {{catchService.calculateTotalFish('pieces', tableDataSource)}}
        </h6>
                  </div>
                  <div class="row add-item" style="padding-top: 15px;"
                    align="center">
                    <div class="col-2"></div>
                    <div class="col-8">
                      <div class="row">
                        <button mat-raised-button
                          class="fishing-button-red"
                          type="button"
                          (click)="updateSpeciesTable(-1)">
                          <span i18n>
                Add New Species
              </span>
                        </button>
                      </div>
                    </div>
                    <div class="col-2"></div>
                  </div>
                </div>
              }
              <!-- Comments -->
              @if (currPage === 5) {
                <div
                  class="container">
                  <div class="row"
                    align="center">
                    <h5 i18n class="blue-heading-title">
          Would you like to add a comment?
        </h5>
                  </div>
                  <div class="row">
                    <h6 i18n class="blue-heading">
          Comments
        </h6>
                    <mat-form-field appearance="fill">
                      <mat-label i18n>
            Comments...
          </mat-label>
                      <textarea matInput
                        maxlength="300"
                        rows="9"
                      formControlName="comments"></textarea>
                    </mat-form-field>
                  </div>
                </div>
              }
              <!-- Summary Page -->
              @if (currPage > numPages) {
                <div
                  class="container">
                  @if (!isComplete && !isEditing) {
                    <div class="row" align="center">
                      <h5 i18n class="blue-heading-title">
          Is all information complete and ready to be submitted to DFO?
        </h5>
                    </div>
                  }
                  @if (isEditing) {
                    <div class="row"
                      align="center">
                      <h5 i18n class="blue-heading-title">
          Are these edits correct and ready to be submitted to Archipelago?
        </h5>
                    </div>
                  }
                  @if (isComplete) {
                    <div class="row">
                      <h6 class="blue-label">
                        <b i18n>
            Confirmation Number:
          </b>
                        @if (offloadReport.confirmationNumber === 'Incomplete' ||
                          offloadReport.confirmationNumber === 'Not submitted' ||
                          offloadReport.confirmationNumber === 'Awaiting response') {
                          <span i18n>
            {offloadReport.confirmationNumber, select, Incomplete {Incomplete} Not submitted {Not submitted} Awaiting response {Awaiting response}}
          </span>
                        } @else {
                          {{offloadReport.confirmationNumber}}
                        }
                      </h6>
                    </div>
                  }
                  @if (this.offloadReport.confirmationNumber == 'Not submitted') {
                    <div>
                      <span i18n class="blue-label">
          Go to the records page to submit outstanding reports
        </span>
                    </div>
                  }
                  @if (reportFailed) {
                    <div class="row">
                      <button mat-raised-button
                        class="fishing-button-red"
                        type="submit"
                        (click)="reopenReport()"
                        style="width: auto; text-align: left;">
                        <span i18n>
            Reopen report
          </span>
                      </button>
                    </div>
                  }
                  <div class="row">
                    <h6 i18n class="blue-label">
          <b>
            Offload Date:
          </b>
          {{ offloadDate | date }}
        </h6>
                  </div>
                  <div class="row">
                    <h6 i18n class="blue-label">
          <b>
            Offload Time:
          </b>
          {{ offloadDate | date:'h:mm a' }}
        </h6>
                  </div>
                  <div class="row">
                    <h6 i18n class="blue-label">
          <b>
            Landing Site:
          </b>
          @if (offloadForm.get('landingSite')?.errors?.required) {
<span class="invalid-field" (click)="navigateToPage(1)">
            [Required]
            <button mat-icon-button (click)="navigateToPage(1)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </span>
}
          @if (!offloadForm.get('landingSite')?.errors?.required) {
<span>
            {{offloadForm.get('landingSite')?.value}}
          </span>
}
        </h6>
                  </div>
                  <div class="row">
                    <h6 class="blue-label">
                      <b i18n>
            Last Management Area Fished:
          </b>
                      @if (offloadForm.get('mgmtArea')?.errors?.required) {
                        <span i18n class="invalid-field" (click)="navigateToPage(2)">
            [Required]
            <button mat-icon-button (click)="navigateToPage(2)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </span>
                      }
                      @if (!offloadForm.get('mgmtArea')?.errors?.required) {
                        <span i18n>
            {offloadForm.get('mgmtArea')?.value, select, Area 1 {Area 1} Area 2 {Area 2} Area 3 {Area 3} Area 4 {Area 4} Area 5 {Area 5} Area 6 {Area 6} Area 7 {Area 7} Area 8 {Area 8} Area 9 {Area 9} Area 10 {Area 10} Area 11 {Area 11} Area 12 {Area 12} Area 13 {Area 13} Area 14 {Area 14} Area 15 {Area 15} Area 16 {Area 16} Area 17 {Area 17} Area 18 {Area 18} Area 19 {Area 19} Area 20 {Area 20} Area 21 {Area 21} Area 22 {Area 22} Area 23 {Area 23} Area 24 {Area 24} Area 25 {Area 25} Area 26 {Area 26} Area 27 {Area 27} Area 28 {Area 28} Area 29 {Area 29} Area 101 {Area 101} Area 102 {Area 102} Area 103 {Area 103} Area 104 {Area 104} Area 105 {Area 105} Area 106 {Area 106} Area 107 {Area 107} Area 108 {Area 108} Area 109 {Area 109} Area 110 {Area 110} Area 111 {Area 111} Area 121 {Area 121} Area 123 {Area 123} Area 124 {Area 124} Area 125 {Area 125} Area 126 {Area 126} Area 127 {Area 127} Area 130 {Area 130} Area 142 {Area 142}}
          </span>
                      }
                    </h6>
                  </div>
                  @if (this.subAreas.length) {
                    <div class="row"
                      >
                      <h6 i18n class="blue-label">
          <b>
            Last Subarea Fished:
          </b>
          @if (offloadForm.get('subarea')?.errors?.required) {
<span class="invalid-field" (click)="navigateToPage(2)">
            [Required]
            <button mat-icon-button (click)="navigateToPage(2)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </span>
}
          @if (!offloadForm.get('subarea')?.errors?.required) {
<span>
            {{offloadForm.get('subarea')?.value}}
          </span>
}
        </h6>
                    </div>
                  }
                  <div class="row">
                    <h6 i18n class="blue-label">
          <b>
            First and Last Date Fished:
          </b>
          @if (offloadForm.get('startDate')?.errors?.required || offloadForm.get('endDate')?.errors?.required) {
<span class="invalid-field" (click)="navigateToPage(2)">
            [Required]
            <button mat-icon-button (click)="navigateToPage(2)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </span>
}
          @if (!offloadForm.get('startDate')?.errors?.required && !offloadForm.get('endDate')?.errors?.required) {
<span>
            {{offloadForm.get('startDate')?.value | date}} - {{offloadForm.get('endDate')?.value | date}}
          </span>
}
        </h6>
                  </div>
                  <div class="row">
                    <h6 i18n class="blue-label">
          <b>
            Number of Days Fished:
          </b>
          @if (offloadForm.get('numDaysFished')?.errors?.required) {
<span class="invalid-field" (click)="navigateToPage(2)">
            [Required]
            <button mat-icon-button (click)="navigateToPage(2)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </span>
}
          @if (!offloadForm.get('numDaysFished')?.errors?.required) {
<span>
            {{offloadForm.get('numDaysFished')?.value}}
          </span>
}
        </h6>
                  </div>
                  <div class="row">
                    <h6 i18n class="blue-label">
          <b>
            Fish Slip Number:
          </b>
          <span>
            {{offloadForm.get('fishSlipNumber')?.value}}
          </span>
        </h6>
                  </div>
                  <div class="row">
                    <h6 class="blue-label">
                      <b i18n>
            Product Type:
          </b>
                      @if (offloadForm.get('productType')?.errors?.required) {
                        <span i18n class="invalid-field" (click)="navigateToPage(3)">
            [Required]
            <button mat-icon-button (click)="navigateToPage(3)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </span>
                      }
                      @if (!offloadForm.get('productType')?.errors?.required) {
                        <span>
                          {{offloadForm.get('productType')?.value}}
                        </span>
                      }
                    </h6>
                  </div>
                  @if (getCurrentGearType() === 'Seine') {
                    <div class="row">
                      <h6 class="blue-label">
                        <b i18n> Total Weight <small>({{offloadForm.get('weightUnits')?.value}}): </small></b>
                        <span>
                          {{catchService.calculateTotalFish('weight', tableDataSource)}}
                        </span>
                      </h6>
                    </div>
                  }
                  <div class="row">
                    <h6 class="blue-label">
                      <b i18n>Total Pieces:</b>
                      <span>
                        {{catchService.calculateTotalFish('pieces', tableDataSource)}}
                      </span>
                    </h6>
                  </div>
                  <div class="row">
                    <h6 i18n class="blue-label">
          <b>Comments:</b>
          <span class="blue-label">
            {{offloadForm.get('comments')?.value}}
          </span>
        </h6>
                  </div>
                </div>
              }
            </form>
            <!-- Page navigation buttons -->
            @if (!isComplete) {
              <div class="row bottom-buttons">
                <div class="col-1"></div>
                <div class="col-4">
                  <div class="row">
                    <button mat-raised-button
                      class="fishing-button-blue"
                      type="button"
                      (click)="toPreviousPage()">
                      <span i18n>
            Back
          </span>
                    </button>
                  </div>
                </div>
                <div class="col-2"></div>
                <div class="col-4">
                  <div class="row">
                    <button mat-raised-button
                      class="fishing-button-red"
                      type="submit"
                      (click)="toNextPage()">
                      @if (currPage <= numPages) {
                        <span i18n>
            Next
          </span>
                      }
                      @if (currPage > numPages) {
                        <span i18n>
            Submit
          </span>
                      }
                    </button>
                  </div>
                </div>
                <div class="col-1"></div>
              </div>
            }
            @if (isComplete) {
              <div class="row bottom-buttons" style="display: flex; justify-content: center;">
                <div class="col-4">
                  <div class="row" style="display: flex; justify-content: center;">
                    <button mat-raised-button
                      class="fishing-button-blue"
                      type="button"
                      (click)="toPreviousPage()">
                      <span i18n>
            Back
          </span>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        }
